import script from "./MiniDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./MiniDialog.vue?vue&type=script&lang=ts&setup=true"

import "./MiniDialog.vue?vue&type=style&index=0&id=1c12e57b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c12e57b"]])

export default __exports__